
import React from 'react';
import BusRatesTable from './BusRatesTable';


const Packages = () => {
  return (
   <div>


<div
      className="breadcumb-wrapper"
      
      data-overlay="black"
      data-opacity="3"
    >
      <div className="container">
        <div className="breadcumb-content text-center">
          <h1 className="breadcumb-title">Packages</h1>
        </div>
      </div>
    </div>



       



    {/* <CabRatesTable/> */}
<BusRatesTable/>
<div className="rules-guidelines container">
  
  <h2>Rules and Guidelines:</h2>
  <ul className="rules-list">
    <li>Full tolls, parking, passenger tax, GST, and special permit charges must be paid by the party.</li>
    <li>Taxes for other states (outside Maharashtra) must be paid by the party as per state requirements.</li>
    <li>Time and meter readings will be recorded before and after the journey.</li>
    <li>The average daily limit is 300 km. For the Mumbai–Mahabaleshwar route, 350 km is allowed.</li>
    <li>A list of passengers and travel destinations must be submitted at least 4 days before departure.</li>
    <li>Bus service is available from 6:00 AM to 12:00 midnight.</li>
    <li>If used after 12:00 midnight, ₹400 per hour will be charged until 2:00 AM. After that, the next day's full 300 km rate will apply.</li>
    <li>For AC usage, an extra ₹500 per hour will be charged.</li>
    <li>At the time of booking, 50% advance payment along with a security deposit must be paid at least 2 days in advance.</li>
    <li>If booking is canceled suddenly, 50% of the total amount will be charged as a cancellation fee.</li>
    <li>Rates are based on current diesel prices (₹100/liter) and may change as per RTO taxes.</li>
    <li>Toll will be deducted via FASTag; the full amount must be paid during final settlement.</li>
    <li>We provide clean vehicles and responsible drivers. For complaints, contact: +91 9209423113.</li>
    <li>There are no hidden or extra charges.</li>
  </ul>

  <h2 className="mt-4">नियम व अटी:</h2>
  <ul className="rules-list">
    <li>टोल, पार्किंग, प्रवासी कर, जीएसटी आणि विशेष परवाना याचा खर्च ग्राहकाने भरायचा आहे.</li>
    <li>इतर राज्यांमध्ये (महाराष्ट्राच्या बाहेर) लागणारे कर ग्राहकाने भरायचे आहेत.</li>
    <li>प्रवास सुरू होण्यापूर्वी व संपल्यानंतर वेळ व मीटर रीडिंग नोंदवली जाईल.</li>
    <li>प्रत्येक दिवशी 300 कि.मी पर्यंतचा प्रवास दरामध्ये समाविष्ट आहे. मुंबई-महाबळेश्वर पॅकेजसाठी 350 कि.मी लागू होतात.</li>
    <li>प्रवासी व प्रवास स्थळांची यादी किमान 4 दिवस आधी कार्यालयात सादर करावी.</li>
    <li>बस सेवा सकाळी 6:00 ते रात्री 12:00 पर्यंत उपलब्ध आहे.</li>
    <li>जर बस रात्री 12:00 नंतर वापरली गेली तर प्रत्येक तासासाठी ₹400 अतिरिक्त शुल्क लागेल (2:00 AM पर्यंत), त्यानंतर पुढील दिवसाचा पूर्ण दर लागू होईल.</li>
    <li>एसी बस वापरल्यास दर तासाला ₹500 अतिरिक्त शुल्क आकारले जाईल.</li>
    <li>बस बुक करताना एकूण रकमेपैकी 50% आगाऊ व सुरक्षा ठेव किमान 2 दिवस आधी भरावी लागेल.</li>
    <li>बुकिंग रद्द केल्यास एकूण रकमेपैकी 50% रक्कम रद्द शुल्क म्हणून आकारली जाईल.</li>
    <li>सध्याच्या डिझेल दर (₹100 प्रति लिटर) वर आधारित दर आहेत व RTO करांनुसार बदल होऊ शकतो.</li>
    <li>बस टोल FASTag द्वारे कापला जाईल व सर्व टोल भरण्याची जबाबदारी ग्राहकाची असेल.</li>
    <li>आम्ही स्वच्छ व व्यवस्थित वाहन आणि जबाबदार चालक देण्याचा प्रयत्न करतो. तक्रारीसाठी संपर्क: +91 9209423113.</li>
    <li>कुठलेही छुपे किंवा अतिरिक्त शुल्क नाहीत.</li>
  </ul>

</div>

   </div>
  );
};

export default Packages;
